import { render } from "./QuestionsResultsSup.vue?vue&type=template&id=53c98026"
import script from "./QuestionsResultsSup.vue?vue&type=script&lang=js"
export * from "./QuestionsResultsSup.vue?vue&type=script&lang=js"

import "./QuestionsResultsSup.vue?vue&type=style&index=0&id=53c98026&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__